<template>
  <div class="cmp-product-carousel utlz-reset utlz-row blocks" :class="{ 'carousel-enabled': useCarousel }">
    <div class="utlz-col-12">
      <!-- BESPOKE EDEX-40: Added v-if="title.length" -->
      <h2 v-if="title.length">{{ title }}</h2>
      <!-- END BESPOKE EDEX-40 -->
    </div>
    <div class="utlz-col-12">
      <transition-group name="fade" tag="div" :class="'scroll-container-' + scrollContainerId" class="scroll-container list-items-wrapper utlz-row">
        <utlz-product-list-item
          @navigateToProductPage="navigateToProductPage($event)"
          v-for="product in products"
          :key="product.id"
          :product="product"
          :blockSize="blockSize"
          class="product-list-item">
        </utlz-product-list-item>
      </transition-group>
    </div>
    <template v-if="useCarousel">
        <div class="nav-controls">
          <!-- BESPOKE EDEX-40: Wrapped all elements n div.nav-controls-wrapper -->
          <div class="nav-controls-wrapper">          
            <transition name="fade">
              <!-- BESPOKE EDEX-40: Removed v-if and assigned classes instead -->
              <div @click="scroll('left')" :class="{ 'disabled': !showControlLeft }" class="nav-control left text-link"><i aria-hidden="true" class="fa fa-angle-left"></i></div>
            </transition>
            <transition name="fade">
              <div @click="scroll('right')"  :class="{ 'disabled': !showControlRight }" class="nav-control right text-link">
                <i aria-hidden="true" class="fa fa-angle-right"></i></div>
            </transition>
            <!-- END BESPOKE EDEX-40 -->
        </div>   
        <!-- END BESPOKE EDEX-40 -->
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProductListItem from 'src/components/webshop/products/product-list-item/ProductListItem.vue';
export default {
  components: {
    'utlz-product-list-item': ProductListItem
  },
  props: {
    title: { type: String, required: false, default: '' },
    blockSize: { type: Number, required: false, default: 4 },
    products: { type: Array, required: true }
  },
  data () {
    return {
      showControlLeft: false,
      showControlRight: true,
      scrollContainerId: ""
    }
  },
  computed: {
    ...mapGetters(['screenWidth']),
    useCarousel () {
      if (this.screenWidth < 576) {
        return this.products.length > 1;
      } else if (this.screenWidth < 992) {
        return this.products.length > 3;
      } else {
        return this.products.length > (12 / this.blockSize);
      }
    }
  },
  methods: {
    scroll (direction) {
      const scrollContainer = document.querySelector('.scroll-container-' + this.scrollContainerId);
      if (direction === 'left') {
        scrollContainer.scrollBy({
          left: -5,
          behavior: 'smooth'
        })
      } else if (direction === 'right') {
        scrollContainer.scrollBy({
          left: scrollContainer.scrollLeft + 5,
          behavior: 'smooth'
        })
      }
      setTimeout(() => {
        this.showControlLeft = scrollContainer.scrollLeft > 0;
        this.showControlRight = scrollContainer.offsetWidth + scrollContainer.scrollLeft !== scrollContainer.scrollWidth;
      }, 350)
    }
  },
  created () {
    this.scrollContainerId = "-"+((new Date).getTime().toString(16)+Math.floor(1E7*Math.random()).toString(16));
  }
}
</script>

<style>

</style>
